import { useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { IoMdShare } from 'react-icons/io'
import { TransparentButton } from 'components/common/button'
import { FaCopy } from 'react-icons/fa'

const ShareStyled = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  .share {
    visibility: hidden;
    opacity: 0;
    transition: 0.5s ease-in opacity;
    position: absolute;
    background: var(--neutral90);
    color: var(--white);
    border-radius: 4px;
    font: var(--smallRegular);
    padding: 6px 8px;
    top: -45px;
    right: -29px;
    &::after {
      content: "";
      position: absolute;
      background: var(--neutral90);
      clip-path: polygon(100% 0, 0 0, 50% 100%);
      width: 12px;
      height: 6px;
      bottom: -6px;
      display: block;
      margin: 0 auto;
      right: 0;
      left: 0;
    }
  }
  &:hover .share {
    visibility: visible;
    opacity: 1;
  }
  .clipboard {
    visibility: ${({ copied }) => (copied ? 'visible' : 'hidden')};
    opacity: ${({ copied }) => (copied ? '1' : '0')};
    position: absolute;
    background-color: #E8EAEF;
    color: var(--basePrimary);
    font-size: 13px;
    text-align: center;
    padding: 4px 8px;
    border-radius: 6px;
    right: 0;
    top: -27px;
    width: 100px;
    ${({ position }) => position === 'center' && `
      background: var(--neutral90);
      color: var(--white);
      padding: 4px 0px;
      position: absolute;
      z-index: 1;
      top: -53px;
      right: -40px;
      &::after {
        content: "";
        position: absolute;
        background: var(--neutral90);
        clip-path: polygon(100% 0, 0 0, 50% 100%);
        width: 12px;
        height: 6px;
        bottom: -6px;
        display: block;
        margin: 0 auto;
        right: 0;
        left: 0;
      }
    `}
    ${({ position }) => position === 'bottomLeft' && `
      bottom: -48px;
      top: auto;
      right: 0;
    `}
    ${({ position }) => position === 'bottomRight' && `
      bottom: -48px;
      top: auto;
      left: 0;
    `}
  }
  @media(min-width: 1024px){
    .clipboard {
      ${({ position }) => position === 'bottomLeft' && `
        bottom: -48px;
        top: auto;
        right: 0;
      `}
      ${({ position }) => position === 'bottomRight' && `
        top: initial;
        right: 0;
        bottom: -48px;
      `}
    }
  }
`

function Share({
  url, title, text, position, color, disabled, copy,
}) {
  const [copied, setCopied] = useState(false)

  function shareSuccess() {
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 4000)
  }

  function handleShare() {
    if (disabled) return null
    // const scroll = commentRef.current.offsetTop - 30
    // window.scrollTo(0, scroll)
    if ('share' in navigator) {
      navigator.share({ title, text, url })
        .then(() => {
          shareSuccess()
        })
        .catch(() => {
          console.log('Operacion Cancelada')
        })
    } else {
      navigator.clipboard.writeText(url)
        .then(() => {
          shareSuccess()
        })
        .catch(() => {
          console.log('Navigator Clipboard not suported')
        })
    }
  }

  return (
    <ShareStyled copied={copied} position={position}>
      <TransparentButton className="share-btn" onClick={() => handleShare()} disabled={disabled}>
        {copy ? (
          <FaCopy size={20} color="var(--turquoise)" />
        ) : (
          <IoMdShare color={color} size={24} />
        )}
      </TransparentButton>
      <span className="clipboard">Copiado al clipboard</span>
      <span className="share">Compartir</span>
    </ShareStyled>
  )
}

Share.defaultProps = {
  color: 'var(--secondary)',
  url: '',
  disabled: false,
  copy: false,
}

Share.propTypes = {
  color: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  copy: PropTypes.bool,
}

export default Share
